/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Send_TitleInputs */

const en_friends_send_title = /** @type {(inputs: Friends_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send to friends`)
};

const de_friends_send_title = /** @type {(inputs: Friends_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An Freunde senden`)
};

/**
* | output |
* | --- |
* | "Send to friends" |
*
* @param {Friends_Send_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_send_title = /** @type {((inputs?: Friends_Send_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Send_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_send_title(inputs)
	return en_friends_send_title(inputs)
});